<div class="min-h-screen bg-white font-serif">

  <!-- HEADING -->
  <div class="bg-[#600b0b] py-3 text-center">
    <h1 class="text-lg md:text-xl text-white font-bold" style="font-family: 'Roboto Slab', serif;">Featured Frame</h1>
  </div>

  <!-- CONTROL BAR -->
<div class="bg-white border-b border-gray-200 sticky top-0 z-30">
    <div class="max-w-[1440px] mx-auto px-4 md:px-8 py-3 flex items-center gap-6">
      <!-- Sort By -->
      <div class="relative shrink-0">
        <button (click)="showSortDropdown = !showSortDropdown"
          class="flex items-center gap-1.5 text-sm md:text-base font-bold text-gray-800 relative z-30">
          Sort By
          <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="currentColor"><path d="M7 10l5 5 5-5z"/></svg>
        </button>
        <p class="text-[10px] text-gray-500 mt-0.5">{{ selectedSort.label }}</p>
        <div *ngIf="showSortDropdown"
          class="absolute left-0 top-full mt-1 bg-white border border-gray-200 rounded shadow-xl py-1 min-w-[200px] z-30">
          <button *ngFor="let sort of sorts" (click)="onSortChange(sort); showSortDropdown = false"
            [class]="'block w-full text-left px-4 py-2.5 text-sm transition-colors ' + (selectedSort === sort ? 'bg-[#600b0b]/5 text-[#600b0b] font-bold' : 'text-gray-600 hover:bg-gray-50')">
            {{ sort.label }}
          </button>
        </div>
      </div>

      <!-- Divider -->
      <div class="w-px h-10 bg-gray-300 shrink-0"></div>

      <!-- Filter -->
      <button (click)="showFilters = !showFilters"
        class="flex items-center gap-1.5 text-sm md:text-base font-bold text-gray-800 hover:text-[#600b0b] transition-colors shrink-0">
        Filter
        <span *ngIf="activeFilters.length > 0" class="bg-[#600b0b] text-white rounded-full min-w-[18px] h-[18px] text-[9px] flex items-center justify-center font-bold px-1">{{ activeFilters.length }}</span>
      </button>

      <!-- Product count (centered) -->
      <div class="flex-1 text-center">
        <span *ngIf="!isLoading" class="text-sm text-[#600b0b] font-medium">{{ totalRecords }} Products</span>
        <span *ngIf="isLoading" class="text-sm text-gray-400 font-medium animate-pulse">Loading...</span>
      </div>
    </div>
  </div>

  <!-- Sort dropdown backdrop -->
  <div *ngIf="showSortDropdown" class="fixed inset-0 z-20" (click)="showSortDropdown = false"></div>

  <!-- ACTIVE FILTER CHIPS -->
  <div *ngIf="activeFilters.length > 0" class="bg-white border-b border-gray-100">
    <div class="max-w-[1440px] mx-auto px-4 md:px-8 py-2 flex items-center gap-2 overflow-x-auto no-scrollbar">
      <span class="text-[9px] font-bold uppercase tracking-widest text-gray-400 shrink-0">Applied:</span>
      <button *ngFor="let chip of activeFilters" (click)="removeFilter(chip)"
        class="flex items-center gap-1 bg-[#600b0b]/5 text-[#600b0b] px-3 py-1 rounded-full text-[10px] font-bold shrink-0 hover:bg-[#600b0b]/10 transition-colors">
        {{ chip.label }}
        <svg xmlns="http://www.w3.org/2000/svg" width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
      </button>
      <button *ngIf="activeFilters.length > 1" (click)="clearAllFilters()"
        class="text-[10px] font-bold text-gray-500 uppercase tracking-wider hover:text-[#600b0b] shrink-0 ml-2">Clear All</button>
    </div>
  </div>

  <!-- MAIN CONTENT -->
  <div class="max-w-[1440px] mx-auto">

    <!-- PRODUCT GRID -->
    <div class="px-4 md:px-8 py-8">

      <!-- Loading skeleton -->
      <div *ngIf="isLoading" class="grid grid-cols-2 md:grid-cols-3 gap-5 md:gap-6">
        <div *ngFor="let i of [1,2,3,4,5,6,7,8,9,10,11,12]">
          <div class="aspect-[4/3] bg-gray-200 animate-pulse"></div>
          <div class="pt-3 space-y-2">
            <div class="h-4 bg-gray-200 rounded animate-pulse w-3/4"></div>
            <div class="h-3 bg-gray-100 rounded animate-pulse w-1/2"></div>
            <div class="h-5 bg-gray-200 rounded animate-pulse w-2/3"></div>
          </div>
        </div>
      </div>

      <!-- No results -->
      <div *ngIf="!isLoading && hasLoaded && products.length === 0" class="text-center py-20">
        <img src="assets/images/data_not_found.jpg" alt="No results" class="w-32 h-32 mx-auto object-contain opacity-50 mb-4"
          (error)="$any($event.target).style.display='none'" />
        <p class="text-gray-500 text-sm">No featured frames found matching your filters.</p>
        <button (click)="clearAllFilters()" class="mt-4 bg-[#600b0b] text-white px-6 py-2.5 rounded-lg text-xs font-bold uppercase tracking-wider hover:bg-[#8c1c1c]">
          Clear Filters
        </button>
      </div>

      <!-- Products Grid -->
      <div *ngIf="!isLoading && products.length > 0" class="grid grid-cols-2 md:grid-cols-3 gap-5 md:gap-6">
        <div *ngFor="let product of products" (click)="navigateToDetail(product)"
          class="group cursor-pointer">

          <!-- Image Container -->
          <div class="relative overflow-hidden bg-gray-100">
            <!-- POPULAR Badge — red ribbon top-left -->
            <div *ngIf="product.popular_art"
              class="absolute top-0 left-0 z-10 bg-[#8c1c1c] text-white text-[10px] md:text-[11px] font-bold uppercase tracking-wide px-3 py-1"
              style="font-family: 'Roboto', sans-serif;">
              POPULAR
            </div>

            <!-- Discount Badge — yellow top-right -->
            <div *ngIf="product.discount > 0"
              class="absolute top-0 right-0 z-10 bg-[#f5d020] text-[#600b0b] text-[10px] md:text-[11px] font-bold px-2.5 py-1"
              style="font-family: 'Roboto', sans-serif;">
              -{{ product.discount }} %
            </div>

            <img [src]="product.hover_thumbnail || product.list_thumbnail" [alt]="product.caption"
              class="w-full aspect-[4/3] object-cover transition-transform duration-500 group-hover:scale-105"
              (error)="$any($event.target).src = 'assets/images/placeholder.png'" />
          </div>

          <!-- Product Info -->
          <div class="pt-3 pb-1 flex items-end">
            <div class="flex-1 min-w-0">
              <!-- Title -->
              <h3 class="text-[13px] md:text-[15px] font-bold text-black truncate" style="font-family: 'Roboto', sans-serif;">
                {{ product.caption }}
              </h3>
              <!-- Size -->
              <p *ngIf="product.final_size" class="text-[11px] md:text-[12px] text-gray-500 mt-0.5" style="font-family: 'Roboto', sans-serif;">
                Size- {{ product.final_size }}
              </p>
              <!-- Price -->
              <div class="mt-1 text-[12px] md:text-[14px]" style="font-family: 'Roboto', sans-serif;">
                <span *ngIf="product.list_price_tax && product.list_price_tax !== product.net_price_tax"
                  class="line-through text-gray-400 font-normal pr-1.5">
                  &#8377;{{ product.list_price_tax | number:'1.2-2' }}
                </span>
                <span class="font-bold text-[#600b0b]">&#8377;{{ product.net_price_tax | number:'1.2-2' }}</span>
              </div>
            </div>

            <!-- Cart & Wishlist Icons (side by side, bottom-right) -->
            <div class="shrink-0 flex items-center gap-0.5 ml-2">
              <!-- Cart -->
              <button class="w-9 h-9 flex items-center justify-center text-gray-600 hover:text-[#600b0b] transition-colors"
                (click)="onAddToCart($event, product)">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
              </button>
              <!-- Wishlist -->
              <button class="w-9 h-9 flex items-center justify-center text-gray-600 hover:text-[#600b0b] transition-colors"
                (click)="onToggleWishlist($event, product)">
                <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24"
                  [attr.fill]="isInWishlist(product) ? '#600b0b' : 'none'"
                  [attr.stroke]="isInWishlist(product) ? '#600b0b' : 'currentColor'" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>

      <!-- Pagination -->
      <div *ngIf="!isLoading && totalPages > 1" class="flex items-center justify-center gap-1.5 md:gap-2 mt-10">
        <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage <= 1"
          class="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-[#600b0b] hover:bg-rose-50 disabled:opacity-30 disabled:cursor-not-allowed transition-all">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="15 18 9 12 15 6"/></svg>
        </button>
        <ng-container *ngFor="let p of pageNumbers">
          <span *ngIf="p === -1" class="text-gray-300 text-xs px-1">...</span>
          <button *ngIf="p !== -1" (click)="goToPage(p)"
            [class]="'w-8 h-8 rounded-full flex items-center justify-center text-xs font-bold transition-all ' + (p === currentPage ? 'bg-[#600b0b] text-white shadow' : 'text-gray-500 hover:bg-rose-50 hover:text-[#600b0b]')">
            {{ p }}
          </button>
        </ng-container>
        <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage >= totalPages"
          class="w-8 h-8 rounded-full flex items-center justify-center text-gray-400 hover:text-[#600b0b] hover:bg-rose-50 disabled:opacity-30 disabled:cursor-not-allowed transition-all">
          <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><polyline points="9 18 15 12 9 6"/></svg>
        </button>
      </div>
    </div>
  </div>

  <!-- FILTER SIDENAV -->
  <div *ngIf="showFilters" class="fixed inset-0 z-50">
    <div class="absolute inset-0 bg-black/40" (click)="showFilters = false"></div>
    <div class="fixed left-0 top-0 bottom-0 w-full max-w-[420px] bg-white flex flex-col shadow-2xl z-50">
      <!-- Header -->
      <div class="px-6 py-5 shrink-0">
        <h2 class="text-lg font-medium text-gray-900" style="font-family: 'Roboto', sans-serif;">Apply Filters</h2>
      </div>
      <!-- Filter panels -->
      <div class="flex-1 overflow-y-auto">
        <ng-container *ngTemplateOutlet="filterPanels"></ng-container>
      </div>
    </div>
  </div>

</div>

<!-- SHARED FILTER PANELS TEMPLATE -->
<ng-template #filterPanels>
  <div class="divide-y divide-gray-200">

    <!-- FILTER: Material (Product Type) -->
    <div class="bg-white">
      <button (click)="expandedPanels['material'] = !expandedPanels['material']"
        class="w-full flex items-center justify-between px-6 py-5">
        <h4 class="text-[15px] font-medium text-gray-800" style="font-family: 'Roboto', sans-serif;">Material</h4>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
          [class]="'transition-transform text-gray-300 ' + (expandedPanels['material'] ? 'rotate-180' : '')"><polyline points="6 9 12 15 18 9"/></svg>
      </button>
      <div *ngIf="expandedPanels['material']" class="px-6 pb-4 space-y-3">
        <div *ngFor="let item of productTypes"
          [class]="'flex items-center gap-3 py-1 cursor-pointer ' + (isFilterDisabled('product_types', item.slug) ? 'opacity-30 pointer-events-none' : '')"
          (click)="toggleFilter(item)">
          <div [class]="'w-[18px] h-[18px] border-2 flex items-center justify-center transition-all shrink-0 ' + (item.activated ? 'bg-[#600b0b] border-[#600b0b]' : 'border-gray-400 bg-white')">
            <svg *ngIf="item.activated" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
          </div>
          <span class="text-[15px] text-gray-700 flex-1">{{ item.name }}</span>
          <span class="text-sm text-gray-400">( {{ getFacetCount('product_types', item.slug) }} )</span>
        </div>
      </div>
    </div>

    <!-- FILTER: Frame Style -->
    <div class="bg-white">
      <button (click)="expandedPanels['frameStyle'] = !expandedPanels['frameStyle']"
        class="w-full flex items-center justify-between px-6 py-5">
        <h4 class="text-[15px] font-medium text-gray-800" style="font-family: 'Roboto', sans-serif;">Frame Style</h4>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
          [class]="'transition-transform text-gray-300 ' + (expandedPanels['frameStyle'] ? 'rotate-180' : '')"><polyline points="6 9 12 15 18 9"/></svg>
      </button>
      <div *ngIf="expandedPanels['frameStyle']" class="px-6 pb-4 space-y-3">
        <div *ngFor="let item of frameStyles"
          [class]="'flex items-center gap-3 py-1 cursor-pointer ' + (isFilterDisabled('frameStyles', item.id) ? 'opacity-30 pointer-events-none' : '')"
          (click)="toggleFilter(item)">
          <div [class]="'w-[18px] h-[18px] border-2 flex items-center justify-center transition-all shrink-0 ' + (item.activated ? 'bg-[#600b0b] border-[#600b0b]' : 'border-gray-400 bg-white')">
            <svg *ngIf="item.activated" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
          </div>
          <span class="text-[15px] text-gray-700 flex-1">{{ item.name }}</span>
          <span class="text-sm text-gray-400">( {{ getFacetCount('frameStyles', item.id) }} )</span>
        </div>
      </div>
    </div>

    <!-- FILTER: Color -->
    <div class="bg-white">
      <button (click)="expandedPanels['color'] = !expandedPanels['color']"
        class="w-full flex items-center justify-between px-6 py-5">
        <h4 class="text-[15px] font-medium text-gray-800" style="font-family: 'Roboto', sans-serif;">Color</h4>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
          [class]="'transition-transform text-gray-300 ' + (expandedPanels['color'] ? 'rotate-180' : '')"><polyline points="6 9 12 15 18 9"/></svg>
      </button>
      <div *ngIf="expandedPanels['color']" class="px-6 pb-4 space-y-3">
        <div *ngFor="let item of colors"
          [class]="'flex items-center gap-3 py-1 cursor-pointer ' + (isFilterDisabled('max_colors', item.name) ? 'opacity-30 pointer-events-none' : '')"
          (click)="toggleFilter(item)">
          <div [class]="'w-[18px] h-[18px] border-2 flex items-center justify-center transition-all shrink-0 ' + (item.activated ? 'bg-[#600b0b] border-[#600b0b]' : 'border-gray-400 bg-white')">
            <svg *ngIf="item.activated" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
          </div>
          <span class="text-[15px] text-gray-700 flex-1">{{ item.name }}</span>
          <span class="text-sm text-gray-400">( {{ getFacetCount('max_colors', item.name) }} )</span>
        </div>
      </div>
    </div>

    <!-- FILTER: Orientation -->
    <div class="bg-white">
      <button (click)="expandedPanels['orientation'] = !expandedPanels['orientation']"
        class="w-full flex items-center justify-between px-6 py-5">
        <h4 class="text-[15px] font-medium text-gray-800" style="font-family: 'Roboto', sans-serif;">Orientation</h4>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
          [class]="'transition-transform text-gray-300 ' + (expandedPanels['orientation'] ? 'rotate-180' : '')"><polyline points="6 9 12 15 18 9"/></svg>
      </button>
      <div *ngIf="expandedPanels['orientation']" class="px-6 pb-4 space-y-3">
        <div *ngFor="let item of orientations"
          [class]="'flex items-center gap-3 py-1 cursor-pointer ' + (isFilterDisabled('orientations', item.id) ? 'opacity-30 pointer-events-none' : '')"
          (click)="toggleFilter(item)">
          <div [class]="'w-[18px] h-[18px] border-2 flex items-center justify-center transition-all shrink-0 ' + (item.activated ? 'bg-[#600b0b] border-[#600b0b]' : 'border-gray-400 bg-white')">
            <svg *ngIf="item.activated" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="3"><polyline points="20 6 9 17 4 12"/></svg>
          </div>
          <span class="text-[15px] text-gray-700 flex-1">{{ item.name }}</span>
          <span class="text-sm text-gray-400">( {{ getFacetCount('orientations', item.id) }} )</span>
        </div>
      </div>
    </div>

    <!-- FILTER: Pricing -->
    <div class="bg-white">
      <button (click)="expandedPanels['pricing'] = !expandedPanels['pricing']"
        class="w-full flex items-center justify-between px-6 py-5">
        <h4 class="text-[15px] font-medium text-gray-800" style="font-family: 'Roboto', sans-serif;">Pricing</h4>
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5"
          [class]="'transition-transform text-gray-300 ' + (expandedPanels['pricing'] ? 'rotate-180' : '')"><polyline points="6 9 12 15 18 9"/></svg>
      </button>
      <div *ngIf="expandedPanels['pricing']" class="px-6 pb-5">
        <p class="text-xs text-gray-500 mb-4">Taxes and fees not included.</p>
        <div class="flex items-center justify-between mb-1">
          <span class="text-base font-medium text-gray-800">&#8377;{{ priceMin }}</span>
          <span class="text-base font-medium text-gray-800">&#8377;{{ priceMax }}</span>
        </div>
        <div class="relative h-10 mt-2 mb-1">
          <div class="absolute top-1/2 -translate-y-1/2 left-0 right-0 h-[3px] bg-gray-300 rounded-full"></div>
          <div class="absolute top-1/2 -translate-y-1/2 h-[3px] bg-[#00BCD4] rounded-full"
            [style.left]="(priceMin / priceMaxLimit * 100) + '%'"
            [style.right]="(100 - priceMax / priceMaxLimit * 100) + '%'"></div>
          <input type="range" [min]="1" [max]="priceMaxLimit" [(ngModel)]="priceMin"
            (input)="onPriceSliderChange()"
            class="absolute top-0 left-0 w-full h-full appearance-none bg-transparent pointer-events-none z-10"
            style="-webkit-appearance: none; -moz-appearance: none;" />
          <input type="range" [min]="1" [max]="priceMaxLimit" [(ngModel)]="priceMax"
            (input)="onPriceSliderChange()"
            class="absolute top-0 left-0 w-full h-full appearance-none bg-transparent pointer-events-none z-20"
            style="-webkit-appearance: none; -moz-appearance: none;" />
        </div>
        <div class="flex items-center justify-between text-[10px] text-gray-400 mb-3">
          <span>Min</span>
          <span>Max</span>
        </div>
        <div class="flex items-center gap-4">
          <div class="flex-1">
            <div class="flex items-center border-b border-gray-300 pb-1">
              <span class="text-sm text-gray-500 mr-1">&#8377;</span>
              <input [(ngModel)]="priceMin" (change)="onPriceSliderChange()" type="number" min="1" [max]="priceMax"
                class="w-full text-sm outline-none bg-transparent text-gray-800" />
            </div>
          </div>
          <div class="flex-1">
            <div class="flex items-center border-b border-gray-300 pb-1">
              <span class="text-sm text-gray-500 mr-1">&#8377;</span>
              <input [(ngModel)]="priceMax" (change)="onPriceSliderChange()" type="number" [min]="priceMin" [max]="priceMaxLimit"
                class="w-full text-sm outline-none bg-transparent text-gray-800" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- CLOSE / CLEAR ALL buttons -->
    <div class="flex mt-2">
      <button (click)="showFilters = false"
        class="flex-1 bg-[#600b0b] text-white text-xs font-bold uppercase tracking-[0.25em] py-4 hover:bg-[#8c1c1c] transition-all">
        APPLY
      </button>
      <button (click)="clearAllFilters(); showFilters = false"
        class="flex-1 bg-white text-gray-600 text-xs font-bold uppercase tracking-[0.25em] py-4 border border-gray-200 hover:text-[#600b0b] transition-all">
        CLEAR ALL
      </button>
    </div>

  </div>
</ng-template>
